import React, { useState, useEffect } from "react";
import Joyride from "react-joyride";
import { changeWalkthrowStatus } from "../Services/Service";
import { tutorial_begin, tutorial_complete } from "../Services/events";
const GuidedTour = () => {
  const [tourStepIndex, setTourStepIndex] = useState(0);
  const [runTour, setRunTour] = useState(false);
  const [tourSteps, setTourSteps] = useState([
    {
      id: "step1",
      target: ".home-Class",
      content: <div style={{ fontSize: "12px" }}>Let's have a Quick Tour</div>,
      disableBeacon: true,
      title: <p className="tooltip-title"> Welcome to ICESPICE !</p>,
      placement: "center",
    },
    {
      id: "step2",
      target: "#spiceGolds",
      title: (
        <p className="tooltip-title">
          This is the IceSpice wallet and it shows your balance SpiceGold.
        </p>
      ),
      content: (
        <div style={{ fontSize: "12px" }}>
          <strong>
            {" "}
            What's SpiceGold{" "}
            <img
              src={"/assets/images/spicegold.png"}
              alt=""
              style={{ height: "20px", width: "20px" }}
            />{" "}
            ?{" "}
          </strong>
          <p>SpiceGold are reward points that you earn while playing games.</p>
          <p>Use SpiceGold to get discounts at the IceSpice store.</p>
          <p>More SpiceGold = More Discounts.</p>
        </div>
      ),
      placement: "top",
    },
    {
      id: "step3",
      target: "#top-deal",
      title: (
        <p className="tooltip-title">
          This is the Top Deal section. Here you can find amazing deals and
          discounts.
        </p>
      ),
      content: (
        <div style={{ fontSize: "12px" }}>
          <p>
            <strong>Top Deals</strong> are special offers with the best
            discounts available.
          </p>
          <p>Check this section regularly for new deals!</p>
        </div>
      ),
      placement: "top",
      onBeforeStep: () => {
        scrollToCenterWithPadding("#top-deal", 50);
      },
    },
    {
      id: "step4",
      target: "#top-deal",
      title: (
        <p className="tooltip-title">
          More SpiceGold{" "}
          <img
            src={"/assets/images/spicegold.png"}
            alt=""
            style={{ height: "17px", width: "20px" }}
          />{" "}
          means More Discounts.
        </p>
      ),
      content: (
        <div style={{ fontSize: "12px" }}>
          <table border="1">
            <tr>
              <th>MRP of the product</th>
              <th>SpiceGold in your account</th>
              <th>Discounted Price (i.e., the amount you pay)</th>
            </tr>
            <tr>
              <td>Rs. 100/-</td>
              <td>Rs. 100/-</td>
              <td>Rs. 80/-</td>
            </tr>
          </table>
          <p>
            SpiceGold used for a purchase gives you the maximum allowed discount
            on that product, regardless of your total SpiceGold balance.
          </p>
        </div>
      ),
      placement: "top",
      // onBeforeStep: () => {
      //   scrollToCenterWithPadding('#deal',50);
      // },
    },
    {
      target: ".home-Class",
      content: (
        <p className="tooltip-title">
          Play More, Earn More{" "}
          <img
            src={"/assets/images/spicegold.png"}
            alt=""
            style={{ height: "20px", width: "20px" }}
          />
        </p>
      ),
      disableBeacon: true,
      placement: "center",
    },
  ]);

  useEffect(() => {
    startTour();
    tutorial_begin();
  });

  const scrollToCenterWithPadding = (selector, padding) => {
    const element = document.querySelector(selector);
    var yourHeight = 21000;
    element.scrollIntoView(true);
    var scrolledY = window.scrollY;
    if (scrolledY) {
      window.scroll(0, scrolledY - yourHeight);
    }
  };
  const handleTourCallback = (data) => {
    console.log(data.action, "action", data.status);
    if (data.action === "next") {
      setTourStepIndex((prevIndex) => prevIndex + 0);
    }
    if (
      data.action === "skip" ||
      (data.status === "finished" && data.type === "tour:end")
    ) {
      tutorial_complete();
      changeWalkthrowStatus(1)
        .then((res) => {
          localStorage.setItem("runTour", "false");
        })
        .then()
        .catch((err) => console.log(err.message));
    }
  };
  const startTour = () => {
    setRunTour(true);
  };
  return (
    <>
      <Joyride
        steps={tourSteps}
        continuous={true}
        disableOverlayClose
        disableCloseOnEsc={true}
        hideCloseButton
        showBackButton={true}
        callback={handleTourCallback}
        run={runTour}
        showProgress={true}
        showSkipButton={true}
        styles={{
          options: {
            arrowColor: "#5caeab",
            backgroundColor: "#fff",
            overlayColor: "rgba(0, 0, 0, .5)",
            primaryColor: "#fff",
            textColor: "#000",
            width: undefined,
            margin: "20px",
            spotlightShadow: "0px 0 15px rgba(0, 0, 0, 0.5)",
            zIndex: 999,
          },
          buttonNext: {
            color: "black",
          },
          buttonBack: {
            top: 0,
            color: "black",
          },
          tooltipContainer: {
            textAlign: "left",
          },
        }}
      />
    </>
  );
};

export default GuidedTour;
